<section class="mb-50">
  <app-reports-card [reportsData]="annualReportsData"></app-reports-card>
</section>
<app-report-not-found></app-report-not-found>
